const BASEPATH = process.env.REACT_APP_BASE_NAME;
const PUBLIC_URL = process.env.PUBLIC_URL || '';
console.log("service worker BASEPATH:", BASEPATH, "PUBLIC_URL:", PUBLIC_URL);
export async function ensureServiceWorkerRegistration() {
  let reg = await navigator.serviceWorker.getRegistration(
    `${PUBLIC_URL}/firebase-messaging-sw.js`,
  );
  if (!reg) {
    reg = await navigator.serviceWorker.register(
      `${PUBLIC_URL}/firebase-messaging-sw.js`,
    );
  }
  return reg;
}
